module.exports = __webpack_public_path__ + "static/img/comunidad-clima-neutral.954eae3b.png";